import type { AuthSession } from '../api/types'

const STORAGE_KEY = 'provisium.market.session'

export const loadStoredSession = (): AuthSession | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    const parsed = JSON.parse(raw) as AuthSession
    if (
      !parsed.accessToken ||
      (parsed.organizationId !== null && typeof parsed.organizationId !== 'number')
    ) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export const saveSession = (session: AuthSession) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export const clearSession = () => {
  localStorage.removeItem(STORAGE_KEY)
}
